module.exports = __webpack_public_path__ + "img/sport.3eba226f.svg";